{
  "openapi": "3.0.0",
  "info": {
    "title": "DREX API",
    "version": "1.0.0",
    "description": "API for user management and file operations."
  },
  "tags": [
    {
      "name": "user_management",
      "description": "Operations related to user management"
    },
    {
      "name": "file_operations",
      "description": "Operations related to file management"
    }
  ],
  "paths": {
    "/": {
      "get": {
        "summary": "Home Page",
        "description": "Return an invalid page message.",
        "responses": {
          "200": {
            "description": "Successful response",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string",
                  "example": "Page Invalid"
                }
              }
            }
          }
        }
      }
    },
    "/helloworld/": {
      "get": {
        "summary": "Hello World",
        "description": "A simple test endpoint.",
        "responses": {
          "200": {
            "description": "Successful response",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object",
                  "properties": {
                    "hello": {
                      "type": "string",
                      "example": "world"
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "/invite-user-same-client": {
      "post": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "summary": "Invite users to the same client.",
        "tags": [
          "user_management"
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "userPrincipalName": {
                      "type": "string"
                    },
                    "userName": {
                      "type": "string"
                    },
                    "role": {
                      "type": "string"
                    }
                  }
                }
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Users invited successfully.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "user": {
                        "type": "string"
                      },
                      "status": {
                        "type": "string"
                      }
                    }
                  }
                }
              }
            }
          },
          "400": {
            "description": "Bad request.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object",
                  "properties": {
                    "error": {
                      "type": "string"
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "/users": {
      "post": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "summary": "Fetch user information and manage roles.",
        "tags": [
          "user_management"
        ],
        "responses": {
          "200": {
            "description": "User information fetched successfully.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object",
                  "properties": {
                    "success": {
                      "type": "object"
                    },
                    "User already exists": {
                      "type": "object"
                    }
                  }
                }
              }
            }
          },
          "400": {
            "description": "Bad request.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object",
                  "properties": {
                    "error": {
                      "type": "string"
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "/invite-user-custom-client": {
      "post": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "summary": "Invite users with a custom client.",
        "tags": [
          "user_management"
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "userPrincipalName": {
                      "type": "string"
                    },
                    "userName": {
                      "type": "string"
                    },
                    "role": {
                      "type": "string"
                    },
                    "client": {
                      "type": "string"
                    }
                  }
                }
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Users invited successfully.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "user": {
                        "type": "string"
                      },
                      "status": {
                        "type": "string"
                      }
                    }
                  }
                }
              }
            }
          },
          "400": {
            "description": "Bad request.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object",
                  "properties": {
                    "error": {
                      "type": "string"
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "/fetch-clients": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "summary": "Fetch list of clients.",
        "tags": [
          "user_management"
        ],
        "responses": {
          "200": {
            "description": "Clients fetched successfully.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "client_name": {
                        "type": "string"
                      },
                      "client_id": {
                        "type": "string"
                      }
                    }
                  }
                }
              }
            }
          },
          "500": {
            "description": "Error fetching clients.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object",
                  "properties": {
                    "error": {
                      "type": "string"
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "/roles-fetch": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "summary": "Fetch user roles.",
        "tags": [
          "user_management"
        ],
        "responses": {
          "200": {
            "description": "Roles fetched successfully.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "type": "string"
                  }
                }
              }
            }
          }
        }
      }
    },
    "/create-client": {
      "post": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "summary": "Create a new client.",
        "tags": [
          "user_management"
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/x-www-form-urlencoded": {
              "schema": {
                "type": "object",
                "properties": {
                  "client_name": {
                    "type": "string"
                  }
                }
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "Client created successfully.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object",
                  "properties": {
                    "message": {
                      "type": "string"
                    },
                    "client_id": {
                      "type": "string"
                    }
                  }
                }
              }
            }
          },
          "500": {
            "description": "Error creating client.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object",
                  "properties": {
                    "error": {
                      "type": "string"
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "/team-members-fetch": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "summary": "Fetch team members for a client.",
        "tags": [
          "user_management"
        ],
        "responses": {
          "200": {
            "description": "Team members fetched successfully.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "UserEmail": {
                        "type": "string"
                      },
                      "FirstName": {
                        "type": "string"
                      },
                      "LastName": {
                        "type": "string"
                      },
                      "Role": {
                        "type": "string"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "/validateToken": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "summary": "Validate user access token.",
        "tags": [
          "user_management"
        ],
        "responses": {
          "200": {
            "description": "Token validated successfully.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          }
        }
      }
    },
    "/signout": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "summary": "Sign out a user.",
        "tags": [
          "user_management"
        ],
        "responses": {
          "200": {
            "description": "User signed out successfully.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          }
        }
      }
    },
    "/getUserInfo": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "summary": "Get user information.",
        "tags": [
          "user_management"
        ],
        "responses": {
          "200": {
            "description": "User information retrieved successfully.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object",
                  "properties": {
                    "FullName": {
                      "type": "string"
                    },
                    "Email": {
                      "type": "string"
                    },
                    "Roles": {
                      "type": "array",
                      "items": {
                        "type": "string"
                      }
                    },
                    "IsPasswordResetRequired": {
                      "type": "boolean"
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "/getUserList": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "summary": "Get the list of users.",
        "tags": [
          "user_management"
        ],
        "responses": {
          "200": {
            "description": "User list retrieved successfully.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "UserEmail": {
                        "type": "string"
                      },
                      "FullName": {
                        "type": "string"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "/getRoles": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "summary": "Get available roles.",
        "tags": [
          "user_management"
        ],
        "responses": {
          "200": {
            "description": "Roles retrieved successfully.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "Name": {
                        "type": "string"
                      },
                      "Code": {
                        "type": "string"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "/assignUsersRole": {
      "post": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "summary": "Assign roles to users.",
        "tags": [
          "user_management"
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "type": "object",
                "properties": {
                  "role": {
                    "type": "object",
                    "properties": {
                      "Name": {
                        "type": "string"
                      }
                    }
                  },
                  "users": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "UserEmail": {
                          "type": "string"
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Roles assigned successfully.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object",
                  "properties": {
                    "success": {
                      "type": "boolean"
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "/resetPassword": {
      "post": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "summary": "Reset a user's password.",
        "tags": [
          "user_management"
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "type": "object",
                "properties": {
                  "new_password": {
                    "type": "string"
                  },
                  "old_password": {
                    "type": "string"
                  }
                }
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Password changed successfully.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object",
                  "properties": {
                    "message": {
                      "type": "string"
                    }
                  }
                }
              }
            }
          },
          "400": {
            "description": "Bad request.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object",
                  "properties": {
                    "error": {
                      "type": "string"
                    }
                  }
                }
              }
            }
          },
          "500": {
            "description": "Internal server error.",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object",
                  "properties": {
                    "error": {
                      "type": "string"
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "/file-upload": {
      "post": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "tags": [
          "file_operations"
        ],
        "summary": "Upload a file",
        "requestBody": {
          "required": true,
          "content": {
            "multipart/form-data": {
              "schema": {
                "type": "object",
                "properties": {
                  "file": {
                    "type": "string",
                    "format": "binary"
                  }
                }
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "File uploaded successfully"
          },
          "401": {
            "description": "Unauthorized"
          }
        }
      }
    },
    "/display/{file_id}": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "tags": [
          "file_operations"
        ],
        "summary": "Display a file",
        "parameters": [
          {
            "name": "file_id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "File details retrieved successfully"
          },
          "404": {
            "description": "File not found"
          }
        }
      }
    },
    "/bloblist-fetch": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "tags": [
          "file_operations"
        ],
        "summary": "Fetch blob list",
        "responses": {
          "200": {
            "description": "Blob list retrieved successfully"
          }
        }
      }
    },
    "/multiple-blobs-fetch": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "tags": [
          "file_operations"
        ],
        "summary": "Fetch multiple blobs",
        "responses": {
          "200": {
            "description": "Multiple blobs retrieved successfully"
          }
        }
      }
    },
    "/multiple-revGrid-fetch": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "tags": [
          "file_operations"
        ],
        "summary": "Fetch multiple revGrid data",
        "responses": {
          "200": {
            "description": "RevGrid data retrieved successfully"
          }
        }
      }
    },
    "/blob-data-fetch/{file_id}": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "tags": [
          "file_operations"
        ],
        "summary": "Fetch blob data by file ID",
        "parameters": [
          {
            "name": "file_id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Blob data retrieved successfully"
          }
        }
      }
    },
    "/drexRevGrid-fetch/{fileID}": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "tags": [
          "file_operations"
        ],
        "summary": "Fetch drexRevGrid data",
        "parameters": [
          {
            "name": "fileID",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "drexRevGrid data retrieved successfully"
          }
        }
      }
    },
    "/total-extracted": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "tags": [
          "file_operations"
        ],
        "summary": "Get total extracted data",
        "responses": {
          "200": {
            "description": "Total extracted data retrieved successfully"
          }
        }
      }
    },
    "/recent-batches": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "tags": [
          "file_operations"
        ],
        "summary": "Fetch recent batches",
        "responses": {
          "200": {
            "description": "Recent batches retrieved successfully"
          }
        }
      }
    },
    "/processed-img-fetch/{fileID}": {
      "get": {
        "security": [
          {
            "BearerAuth": []
          }
        ],
        "tags": [
          "file_operations"
        ],
        "summary": "Fetch processed image by file ID",
        "parameters": [
          {
            "name": "fileID",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Processed image retrieved successfully"
          }
        }
      }
    }
  },
  "components": {
    "securitySchemes": {
      "BearerAuth": {
        "type": "http",
        "scheme": "bearer",
        "bearerFormat": "LoginRadius access token"
      }
    }
  },
  "security": [
    {
      "BearerAuth": []
    }
  ]
}